/* Section Heroes quantity tiles handle their own selection, cart quantity and
   discount. This only rewrites our price block — price / compare-at / saving /
   shipping — so everything above the button describes the same cart line.
   Also drives the fallback stepper used when the app block isn't installed. */
(function () {
  // de-DE + € is the storefront's locale; trailing ,00 is dropped per 1.2
  function money(cents) {
    return (cents / 100)
      .toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .replace(/,00$/, '') + '€';
  }

  function selectedBlock() {
    var sel = document.querySelector('.sh-buy__app .sh-bundle-block-content.selected');
    return sel && sel.closest('.sh-bundle-block');
  }

  /* Do NOT write the tier quantity into the form. The app multiplies the form's
     quantity by the selected tier itself, so setting it here squares it —
     picking 3 Stück added 9. The form stays at 1 and the app scales it. */

  /* Variant resolution — the app's picker is not the theme's, so nothing else knows
     the choice. Resolve it against the price block's map and drive the page from it. */
  var variantMap = null;
  var chosen = null;

  function variants() {
    if (variantMap) return variantMap;
    var node = document.querySelector('[data-sh-variant-map]');
    try {
      variantMap = node ? JSON.parse(node.textContent) : [];
    } catch (e) {
      variantMap = [];
    }
    return variantMap;
  }

  /* the theme's own picker block, when the merchant added it */
  function nativePicker() {
    return document.querySelector('.sh-hero__buy [data-sh-variants][data-sh-native]');
  }

  function pickOf(sel, pos, picks) {
    var opt = sel.options[sel.selectedIndex];
    picks[pos - 1] = { value: sel.value, text: opt ? opt.textContent.trim() : '' };
  }

  /* values may be the option name or its label */
  function pickedOptions(block) {
    var picks = [];
    var native = nativePicker();

    if (native) {
      native.querySelectorAll('[data-sh-option]').forEach(function (sel) {
        pickOf(sel, parseInt(sel.getAttribute('data-sh-option'), 10) || picks.length + 1, picks);
      });
      return picks.length ? picks : null;
    }

    var lead = block && block.querySelector('.sh-bundle-variant-picker-row');
    if (!lead) return null;

    lead.querySelectorAll('select').forEach(function (sel) {
      pickOf(sel, parseInt(sel.getAttribute('data-option-position'), 10) || picks.length + 1, picks);
    });
    return picks.length ? picks : null;
  }

  function matchVariant(picks) {
    var all = variants();
    for (var i = 0; i < all.length; i++) {
      var ok = picks.every(function (pick, j) {
        if (!pick) return true;
        var value = all[i].options[j];
        return value === pick.value || value === pick.text;
      });
      if (ok) return all[i];
    }
    return null;
  }

  /* repoint what the price block derives from the variant; no-op when unchanged */
  function applyVariant(block) {
    var group = document.querySelector('.sh-hero__buy [data-sh-price]');
    if (!group) return;

    var picks = pickedOptions(block);
    var variant = picks ? matchVariant(picks) : null;
    if (!variant) return;

    chosen = variant;

    var form = document.querySelector('.sh-buy__form input[name="id"]');
    if (form && String(form.value) === String(variant.id)) return;

    group.setAttribute('data-item-price', variant.price);
    group.setAttribute('data-unit-price', variant.unit || 0);
    group.setAttribute('data-unit-compare', variant.compare || 0);

    var unit = group.querySelector('[data-sh-unit]');
    var unitRef = group.querySelector('[data-sh-unit-ref]');
    if (unit) unit.hidden = !variant.unit;
    if (unitRef) unitRef.textContent = variant.unitRef || '';

    if (form) {
      form.value = variant.id;
      form.disabled = !variant.available;
    }

    // a sold-out weight must not be addable — the app posts through this button
    var button = document.querySelector('.sh-buy__form [data-add-to-cart]');
    if (button) button.disabled = !variant.available;

    // nothing re-fetches the section here, so the button copy is ours to keep honest
    var label = button && button.querySelector('[data-add-to-cart-text]');
    if (label) {
      var copy = label.getAttribute(variant.available ? 'data-sh-label' : 'data-sh-soldout');
      if (copy) label.textContent = copy;
    }

    /* the notification form stands in for the dead button, and has to name the weight
       it was filled in for — the control gets that from a section re-fetch */
    var notify = document.querySelector('.sh-hero__buy [data-sh-notify]');
    if (notify) {
      notify.hidden = variant.available;

      var forProduct = notify.querySelector('[data-notification-product]');
      if (forProduct) {
        forProduct.value = notify.getAttribute('data-sh-product') + ' - ' + (variant.title || '');
      }
    }

    // shareable and alive across a refresh, as the theme's own picker is
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      /* older browsers simply keep the current URL */
    }
  }

  /* The tier's undiscounted PER-PIECE price. The app's data-base-price is the tier
     total — variant price × quantity — so dividing recovers the unit exactly. */
  function tierUnit(block) {
    if (chosen && chosen.price) return chosen.price;
    var qty = parseInt(block.getAttribute('data-quantity'), 10) || 1;
    return Math.round((parseInt(block.getAttribute('data-base-price'), 10) || 0) / qty);
  }

  /* the tier's undiscounted total, from the chosen variant rather than the app's
     data-base-price, so it is right before the app re-renders */
  function tierBase(block) {
    var qty = parseInt(block.getAttribute('data-quantity'), 10) || 1;
    if (chosen && chosen.price) return chosen.price * qty;
    return parseInt(block.getAttribute('data-base-price'), 10) || 0;
  }

  /* Percentage tiers are priced per piece: discount one unit, round that price DOWN
     to a whole cent, then multiply out. That is exactly what the app's discount
     function charges, so per-piece × quantity equals the cart total.

     Discounting the tier total instead leaves a sub-cent remainder that no per-piece
     figure can carry — 40,29 / 6 = 6,715 — and the page ends up showing three
     different numbers: 40,29 in the price block, 6,72 on the tile, 40,26 in the cart.

     Rounding down always lands in the customer's favour, by at most one cent per
     piece, so a tier never delivers less than the advertised percentage. */
  function tierTotal(block) {
    var base = tierBase(block);
    var value = parseFloat(block.getAttribute('data-discount-value')) || 0;
    if (!base || !value) return base;
    if (block.getAttribute('data-discount-type') !== 'percentage') return base - value;

    var qty = parseInt(block.getAttribute('data-quantity'), 10) || 1;
    // the epsilon absorbs float drift, so a unit that divides exactly does not floor
    // to the cent below — 10,00€ at 10% must stay 9,00€, not 8,99€
    return Math.max(0, Math.floor((tierUnit(block) * (100 - value)) / 100 + 1e-9)) * qty;
  }

  function syncPrice(block) {
    var group = document.querySelector('.sh-hero__buy [data-sh-price]');
    if (!group) return;

    var qty = parseInt(block.getAttribute('data-quantity'), 10) || 1;
    var total = tierTotal(block);

    // the tiles show per-piece now, so derive the total instead of copying them
    var priceEl = group.querySelector('[data-sh-price-value]');
    if (priceEl) priceEl.textContent = money(total);
    var unitCompare = parseInt(group.getAttribute('data-unit-compare'), 10) || 0;
    var compareTotal = Math.max(unitCompare * qty, tierBase(block));
    if (compareTotal <= total) compareTotal = 0;

    // red is for a price with something struck out beside it — see .sh-buy__price--sale
    if (priceEl) priceEl.classList.toggle('sh-buy__price--sale', compareTotal > 0);

    var compareEl = group.querySelector('[data-sh-compare]');
    if (compareEl) {
      if (compareTotal) compareEl.textContent = money(compareTotal);
      compareEl.hidden = !compareTotal;
    }

    /* scale the unit price by the tier's per-piece change, so "…€/100g" cannot
       contradict the figure above it. total / qty is a whole cent by construction,
       so this converts a real per-piece price into the reference measure. */
    var unitEl = group.querySelector('[data-sh-unit-value]');
    var unitBase = parseInt(group.getAttribute('data-unit-price'), 10) || 0;
    var itemBase = parseInt(group.getAttribute('data-item-price'), 10) || 0;
    if (unitEl && unitBase && itemBase) {
      unitEl.textContent = money(Math.round((unitBase * (total / qty)) / itemBase));
    }

    var savingEl = group.querySelector('[data-sh-saving]');
    if (savingEl) {
      if (compareTotal) {
        savingEl.textContent =
          (group.getAttribute('data-saving-label') || '') + ' ' + money(compareTotal - total);
      }
      savingEl.hidden = !compareTotal;
    }

    // the threshold is judged on what's actually being paid, so it can flip
    // to free shipping once a multi-pack clears the limit
    var shippingEl = group.querySelector('[data-sh-shipping]');
    var limit = parseInt(group.getAttribute('data-free-limit'), 10) || 0;
    if (shippingEl && limit) {
      if (total >= limit) {
        shippingEl.innerHTML = '<span class="sh-buy__shipping"></span>';
        shippingEl.firstChild.textContent = group.getAttribute('data-free-note') || '';
      } else {
        shippingEl.textContent = group.getAttribute('data-paid-note') || '';
      }
    }
  }

  /* No bundle app, so no tiers: the figures are simply the chosen variant's. */
  function syncPlain() {
    var group = document.querySelector('.sh-hero__buy [data-sh-price]');
    if (!group || !chosen) return;

    var priceEl = group.querySelector('[data-sh-price-value]');
    if (priceEl) {
      priceEl.textContent = money(chosen.price);
      priceEl.classList.toggle('sh-buy__price--sale', chosen.compare > chosen.price);
    }

    var markdown = chosen.compare > chosen.price ? chosen.compare : 0;

    var compareEl = group.querySelector('[data-sh-compare]');
    if (compareEl) {
      if (markdown) compareEl.textContent = money(markdown);
      compareEl.hidden = !markdown;
    }

    var savingEl = group.querySelector('[data-sh-saving]');
    if (savingEl) {
      if (markdown) {
        savingEl.textContent =
          (group.getAttribute('data-saving-label') || '') + ' ' + money(markdown - chosen.price);
      }
      savingEl.hidden = !markdown;
    }

    var unitEl = group.querySelector('[data-sh-unit-value]');
    if (unitEl && chosen.unit) unitEl.textContent = money(chosen.unit);

    var shippingEl = group.querySelector('[data-sh-shipping]');
    var limit = parseInt(group.getAttribute('data-free-limit'), 10) || 0;
    if (shippingEl && limit) {
      if (chosen.price >= limit) {
        shippingEl.innerHTML = '<span class="sh-buy__shipping"></span>';
        shippingEl.firstChild.textContent = group.getAttribute('data-free-note') || '';
      } else {
        shippingEl.textContent = group.getAttribute('data-paid-note') || '';
      }
    }
  }

  /* The app prints the line total under a "pro Stück" label. Rewrite each tile to
     the per-piece figure; the total stays in the price block above. Derived from
     the data attributes, never from the rendered text, so re-running is safe.
     tierTotal is a whole multiple of the per-piece price, so the division below is
     exact — the tile times its quantity is always the price block's total. */
  function syncTiles() {
    var blocks = document.querySelectorAll('.sh-buy__app .sh-bundle-block');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var el = block.querySelector('.sh-bundle-block-content-item-price-total');
      if (!el) return;
      var qty = parseInt(block.getAttribute('data-quantity'), 10) || 1;
      var text = money(Math.round(tierTotal(block) / qty));
      if (el.textContent.trim() !== text) el.textContent = text;
      el.setAttribute('data-sh-priced', '');

      // a line total as well, so 2 Stück would read "8,46€" against "17,80€"
      var cmp = block.querySelector('.sh-bundle-block-content-item-price-compareAt');
      if (!cmp) return;
      var base = tierBase(block);
      if (!base) return;
      var cmpText = money(Math.round(base / qty));
      if (cmp.textContent.trim() !== cmpText) cmp.textContent = cmpText;
      cmp.setAttribute('data-sh-priced', '');
    });
  }

  /* Variant pickers — the app prints one per piece inside each tile. The originals
     stay hidden (it reads them); above the tiles we show one control per option and
     fan a change out to every piece of the tier. */
  function variantHost() {
    // every app block has a .sh-buy__app wrapper, so work outwards from the widget
    var widget = document.querySelector('.sh-buy__app .sh-bundle');
    var app = widget && widget.closest('.sh-buy__app');
    if (!app) return null;

    var host = app.querySelector('[data-sh-variants]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'sh-buy__variants';
      host.setAttribute('data-sh-variants', '');
      // above the bundle's headline, and outside .sh-bundle so our writes do not
      // feed the observer that calls us back
      app.insertBefore(host, app.firstChild);
    }
    return host;
  }

  /* the option position is what lets one control stand in for every slot */
  function optionKey(sel) {
    return sel.getAttribute('data-option-position') || sel.getAttribute('data-option-name') || '';
  }

  function slotSelects(block, key) {
    return Array.prototype.filter.call(
      block.querySelectorAll('.sh-bundle-variant-picker-row select'),
      function (sel) {
        return optionKey(sel) === key;
      }
    );
  }

  function variantSignature(leads, slots) {
    return (
      slots +
      '#' +
      leads
        .map(function (sel) {
          return optionKey(sel) + ':' + sel.options.length + '@' + sel.value;
        })
        .join(',')
    );
  }

  /* Each tier carries its own slot selects, sitting at the app's defaults, so a tier
     switch would otherwise throw the customer's choice away. Remember it and write
     it into whichever tier is selected — weight and quantity stay independent. */
  var picked = {};

  function applyPicked(block) {
    Object.keys(picked).forEach(function (key) {
      var want = picked[key];

      slotSelects(block, key).forEach(function (sel) {
        var match = Array.prototype.filter.call(sel.options, function (opt) {
          return opt.value === want.value || opt.textContent.trim() === want.text;
        })[0];
        if (!match || sel.value === match.value) return;
        sel.value = match.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* the clone must not look like a form field or one of the app's own controls, or it
     would post a second value; on change every slot of the tier takes the value */
  function proxyFor(orig, id, block) {
    var key = optionKey(orig);

    var proxy = orig.cloneNode(true);
    proxy.removeAttribute('name');
    Array.prototype.slice.call(proxy.attributes).forEach(function (attr) {
      if (attr.name.indexOf('data-') === 0) proxy.removeAttribute(attr.name);
    });
    proxy.id = id;
    proxy.value = orig.value;

    // one value is no choice — matches the theme picker's inert state
    if (proxy.options.length < 2) {
      proxy.setAttribute('data-sh-single', '');
      proxy.setAttribute('tabindex', '-1');
      proxy.setAttribute('aria-disabled', 'true');
    }

    proxy.addEventListener('change', function () {
      var opt = proxy.options[proxy.selectedIndex];

      if (key) {
        picked[key] = { value: proxy.value, text: opt ? opt.textContent.trim() : '' };
        applyPicked(block);
      } else if (orig.value !== proxy.value) {
        orig.value = proxy.value;
        orig.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // repaint now, or price and URL lag a click behind the app's own re-render
      sync();
    });

    return proxy;
  }

  function syncVariants(block) {
    // the theme's own picker is already the control — nothing to mirror
    if (nativePicker()) return;

    var host = variantHost();
    if (!host) return;

    // one control per option, from the first slot — not one per piece
    var lead = block && block.querySelector('.sh-bundle-variant-picker-row');
    var leads = lead ? Array.prototype.slice.call(lead.querySelectorAll('select')) : [];

    if (!leads.length) {
      host.hidden = true;
      host.innerHTML = '';
      host.removeAttribute('data-sh-sig');
      return;
    }

    // a rebuild blows away focus, so only do it on a change
    var slots = block.querySelectorAll('.sh-bundle-variant-picker-row').length;
    var sig = (block.getAttribute('data-offer-index') || '') + '#' + variantSignature(leads, slots);
    host.hidden = false;
    if (host.getAttribute('data-sh-sig') === sig) return;
    host.setAttribute('data-sh-sig', sig);
    host.innerHTML = '';

    var line = document.createElement('div');
    line.className = 'sh-buy__variant';

    leads.forEach(function (orig, j) {
      var id = 'sh-variant-' + j;
      var option = orig.closest('.sh-bundle-option');
      var text = option && option.querySelector('label');

      if (text && text.textContent.trim()) {
        var label = document.createElement('label');
        label.className = 'sh-buy__variant-label';
        label.setAttribute('for', id);
        label.textContent = text.textContent.trim();
        line.appendChild(label);
      }

      line.appendChild(proxyFor(orig, id, block));
    });

    host.appendChild(line);
  }

  function sync() {
    var block = selectedBlock();
    // variant first: the figures below derive from it
    if (block) applyPicked(block);
    applyVariant(block);
    syncVariants(block);
    syncTiles();
    if (block) syncPrice(block);
    else syncPlain();
  }

  /* Fallback stepper — only present when the app block isn't used, so it never
     competes with the tiles. Its input posts natively via form="…". */
  function initStepper() {
    document.querySelectorAll('.sh-hero__buy .sh-buy__qty-control').forEach(function (ctl) {
      var input = ctl.querySelector('[data-sh-qty-input]');
      if (!input || ctl.dataset.shBound) return;
      ctl.dataset.shBound = '1';

      var min = parseInt(input.min, 10) || 1;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var step = parseInt(input.step, 10) || 1;
      var minus = ctl.querySelector('[data-sh-step="-1"]');

      function clamp() {
        var v = Math.min(max, Math.max(min, parseInt(input.value, 10) || min));
        input.value = v;
        if (minus) minus.disabled = v <= min;
      }

      ctl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sh-step]');
        if (!btn) return;
        input.value = (parseInt(input.value, 10) || min) + step * parseInt(btn.dataset.shStep, 10);
        clamp();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', clamp);
      clamp();
    });
  }

  function bindNative() {
    var native = nativePicker();
    if (!native || native.dataset.shBound) return;
    native.dataset.shBound = '1';

    /* Seed from what the page rendered, so the app's own slot defaults follow the
       variant in the URL rather than the other way round. */
    native.querySelectorAll('[data-sh-option]').forEach(function (sel) {
      var key = sel.getAttribute('data-sh-option');
      var opt = sel.options[sel.selectedIndex];
      picked[key] = { value: sel.value, text: opt ? opt.textContent.trim() : '' };

      sel.addEventListener('change', function () {
        var now = sel.options[sel.selectedIndex];
        picked[key] = { value: sel.value, text: now ? now.textContent.trim() : '' };
        var block = selectedBlock();
        if (block) applyPicked(block);
        sync();
      });
    });
  }

  /* An app block the merchant kept but that renders nothing for this product still
     holds its slot in the column's gap. Apps inject late, so keep watching. */
  function trimEmptyApps() {
    var column = document.querySelector('.sh-hero__buy');
    /* Both A/B arms ship in one template and the losing one stays display:none, where
       every box measures 0. A verdict taken then would condemn app blocks that are
       perfectly full, so wait until the column is actually laid out. */
    if (!column || !column.getClientRects().length) return;

    column.querySelectorAll('.sh-buy__app').forEach(function (app) {
      /* Show it before measuring: a hidden element always reports 0, so judging it in
         place would keep the first wrong guess forever — hidden feeds its own test. */
      app.hidden = false;
      app.hidden = !(app.children.length > 0 && app.scrollHeight > 0);
    });
  }

  function watchApps() {
    var column = document.querySelector('.sh-hero__buy');
    if (!column) return;

    var pending = false;
    function queue() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        trimEmptyApps();
      });
    }

    trimEmptyApps();

    new MutationObserver(queue).observe(column, { subtree: true, childList: true });

    /* The variation reveals the section with CSS, which fires no mutation. The column
       growing from nothing to its real size is the only signal that we may measure. */
    if (window.ResizeObserver) new ResizeObserver(queue).observe(column);
  }

  function boot() {
    initStepper();
    bindNative();
    watchApps();

    var widget = document.querySelector('.sh-buy__app .sh-bundle');
    if (!widget) {
      sync();
      return;
    }

    sync();

    // the app re-renders its own tiles and toggles .selected — watch rather than
    // bind clicks, so we stay correct when it swaps nodes
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        sync();
      });
    }).observe(widget, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();